import { render } from "./DeleteAccountManualView.vue?vue&type=template&id=58b5b50e&ts=true"
import script from "./DeleteAccountManualView.vue?vue&type=script&lang=ts"
export * from "./DeleteAccountManualView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__